import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { BuyMusicChannelRequest } from '../api/wishlist/buymusicchannel/buymusicchannelrequest';
import { BuyMusicChannelResponse, BuyMusicChannelResponseDtoImpl } from '../api/wishlist/buymusicchannel/buymusicchannelresponse';
import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';
import { SixdeeCRBTAPIProcessor } from './sixdeecrbtapiprocessor';
import { Strings } from '../../utils/resources/strings';

export class BuyMusicChannelAPIProcessorImpl extends SixdeeCRBTAPIProcessor<BuyMusicChannelRequest, BuyMusicChannelResponse>
{
    execute(request: BuyMusicChannelRequest): void 
    {
        super.execute(request);
    }

    onSuccess(responseMapper: ResponseMapper): void 
    {
        super.onSuccess(responseMapper);
        try {

            if (+responseMapper.getStatusCode() === StatusCodes.SUCCESS) {

                let response = new BuyMusicChannelResponseDtoImpl(APIFeatures.BUY_MUSIC_CHANNEL, "Buy Music Channel Success");

                this.getAPISuccess(response);
            }
        }
        catch (e) {
            this.getAPIFailure(new BuyMusicChannelResponseDtoImpl(APIFeatures.BUY_MUSIC_CHANNEL, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
        super.onFailure(responseMapper);
      
            this.getAPIFailure(new BuyMusicChannelResponseDtoImpl(APIFeatures.BUY_MUSIC_CHANNEL, responseMapper.getStatusMsg()));
        
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/buymusicchannelapiprocessor.tsx